import { Table, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import type { PayrollBundleExpenseCategoryFragment } from 'generated/resources/graphql'

import type { LegalEntities } from 'modules/core/store/collections/legalEntities'

import type Taxonomy from 'modules/contracts/store/models/Taxonomy'
import type { ExpensesCategoriesContractsTaxonomies } from 'modules/payroll_bundle/store/collections/expensesCategoriesContractsTaxonomies'

import ExpenseMappingDropdown from './ExpenseMappingDropdown'

interface TaxonomiesByLegalEntity {
  [key: number]: Taxonomy[]
}

const ExpenseMappingsRow = ({
  expensesCategory,
  legalEntities,
  taxonomiesByLegalEntity,
  expensesCategoriesContractsTaxonomies,
}: {
  expensesCategory: PayrollBundleExpenseCategoryFragment
  legalEntities: LegalEntities
  taxonomiesByLegalEntity: TaxonomiesByLegalEntity
  expensesCategoriesContractsTaxonomies: ExpensesCategoriesContractsTaxonomies
}) => {
  const mapping = (legalEntityId: number) =>
    expensesCategoriesContractsTaxonomies.findByExpensesCategoryAndTaxonomies({
      expensesCategoryId: expensesCategory.identifier,
      taxonomyIds: (taxonomiesByLegalEntity[legalEntityId] || []).map((t) => t.id),
    }) ||
    expensesCategoriesContractsTaxonomies.build({
      expenses_category_id: expensesCategory.identifier,
    })

  return (
    <Table.Row>
      <Table.Cell sticky={{ position: 'left', delimiter: true }}>
        <Text.Normal>{expensesCategory.label}</Text.Normal>
      </Table.Cell>
      {legalEntities.map((legalEntity) => (
        <Table.Cell key={legalEntity.id}>
          <ExpenseMappingDropdown
            taxonomies={taxonomiesByLegalEntity[legalEntity.id] || []}
            mapping={mapping(legalEntity.id)}
          />
        </Table.Cell>
      ))}
    </Table.Row>
  )
}

export default observer(ExpenseMappingsRow)
